import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IonAlert, IonToast } from '@ionic/react';
import { isDefined } from '../../lib/utils';
import { removeToast } from '../../store/actions';
import { withTranslation } from '../../lib/translate';
import { getConfig } from '../../appConfig.js';

class Toast extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isConnectedEstablished: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isConnectedToNetwork && this.props.isConnectedToNetwork) {
      //show connection established toast only /if we have scenario: offline -> online
      this.setState({ isConnectedEstablished: true });
    }
  }

  showToast = () => {
    const { message, toastType, __, removeToast, title } = this.props;
    return (
      <IonAlert
        isOpen={true}
        onDidDismiss={() => {
          removeToast(); // removes original toast
          removeToast(); // removes separator toast (empty one)
        }}
        header={__(title)}
        message={__(message)}
        cssClass="no-table-alert one-red-button-alert"
        buttons={[
          {
            cssClass: 'two-button-secondary',
            text: __('OK'),
          },
        ]}
      />
    );
  };

  render() {
    const { message, isConnectedToNetwork, __ } = this.props;
    const { isConnectedEstablished } = this.state;

    if (isConnectedEstablished) {
      return (
        <IonToast
          isOpen={true}
          color="success"
          message="Connection established"
          duration={5000}
          showCloseButton
          onDidDismiss={() => this.setState({ isConnectedEstablished: false })}
        />
      );
    }
    if (isDefined(isConnectedToNetwork) && !isConnectedToNetwork) {
      //show connection toast
      return <IonToast isOpen={true} color="danger" message={__('Connection lost!')} />;
    } else {
      //all other toasts
      return isDefined(message) && message !== '' ? this.showToast() : null;
    }
  }
}

const stateToProps = (state) => {
  const { common } = state;
  let message = '';
  let toastType = 'warning';
  let title = '';
  if (common && common.toast && common.toast.length > 0) {
    message = common.toast[0].message;
    toastType = common.toast[0].toastType;
    title = common.toast[0].title;
  }

  return {
    message,
    toastType,
    isConnectedToNetwork: common.isConnectedToNetwork,
    title,
  };
};

const dispatchToProps = (dispatch) => {
  return {
    removeToast: () => dispatch(removeToast()),
  };
};

export default connect(stateToProps, dispatchToProps)(withTranslation(Toast));
